import styled, { keyframes } from 'styled-components';

const fadeInDown = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const NavWrapper = styled.nav`
  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    position: sticky;
    top: 0;
    top: constant(safe-area-inset-top);
    top: env(safe-area-inset-top);
    z-index: 9999;
    background: #ffffff;
  }
`;

export const NavContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 8.8rem;
  padding-left: 10rem;
  padding-right: 10rem;

  background: #ffffff;
  top: 0;
  z-index: 9999;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    padding: 2rem 2rem;
    box-shadow: 0 8px 16px -12px rgba(0, 0, 0, 0.35);
  }
`;

export const LogoContainer = styled.div`
  width: 18rem;
  height: 5.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    width: 15.1rem;
    height: 4.9rem;
  }
`;

export const Logo = styled.img<{ isMobile: boolean }>`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 6rem;
  margin-right: 4rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    display: none;
  }
`;

export const NavLink = styled.a<{ buttonStyle?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;

  border: ${({ buttonStyle, theme }) =>
    buttonStyle ? `2px solid ${theme.color.mobilityBlue}` : 'none'};
  border-radius: ${({ buttonStyle, theme }) =>
    buttonStyle ? theme.borderRadius.radius5 : '0'};
  color: ${({ theme, buttonStyle }) =>
    buttonStyle ? theme.color.mobilityBlue : theme.color.mobilityGrey};

  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme, buttonStyle }) =>
    buttonStyle ? theme.fontWeight.weight700 : theme.fontWeight.weight600};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  font-family: proxima-nova, sans-serif;
  text-decoration: none;
  position: relative;
  padding: ${({ buttonStyle }) => (buttonStyle ? '0.8rem 2rem' : '0')};

  &:hover,
  &.active {
    background-color: ${({ buttonStyle, theme }) =>
      buttonStyle ? theme.color.mobilityBlue : theme.color.white};
    color: ${({ theme, buttonStyle }) =>
      buttonStyle ? theme.color.white : theme.color.mobilityBlue};
  }
`;

export const DropdownMenu = styled.div`
  display: none;
  position: absolute;
  top: calc(100% + 1.5rem);
  left: 0;
  min-width: 220px;
  background: #fff;
  border-radius: 1rem;
  padding: 1rem 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  animation: ${fadeInDown} 0.3s ease-out;
  z-index: 1000;
`;

export const DropdownItem = styled.a`
  display: block;
  padding: 1rem 2rem;
  text-decoration: none;
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;

  &:hover,
  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
    background: ${({ theme }) => theme.color.lightGrey};
  }
`;

export const MobileMenuIcon = styled.div`
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size40};
  cursor: pointer;
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    display: block;
    position: relative;
    top: -5px;
  }
`;

export const MobileMenu = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.color.white};
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

export const MobileMenuHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 2rem 2rem 2rem 2rem;
  margin-bottom: 6rem;
  width: 100%;

  border-bottom: 1px solid ${({ theme }) => theme.color.mobilityGrey};
`;

export const MobileMenuContent = styled.div`
  width: 100%;
  flex: 1;
`;

export const MobileNavLink = styled.a<{ buttonStyle?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  width: ${({ buttonStyle }) => (buttonStyle ? '90%' : '100%')};

  border: ${({ buttonStyle, theme }) =>
    buttonStyle ? `2px solid ${theme.color.mobilityBlue}` : 'none'};
  border-radius: ${({ buttonStyle, theme }) =>
    buttonStyle ? theme.borderRadius.radius5 : '0'};
  color: ${({ theme, buttonStyle }) =>
    buttonStyle ? theme.color.mobilityBlue : theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};
  text-decoration: none;

  padding: 1.2rem;
  margin-top: ${({ buttonStyle }) => (buttonStyle ? '4rem' : '1rem')};
  margin-bottom: 1rem;

  &:hover,
  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const MobileDropdownMenuStyled = styled.div<{ height: number }>`
  background-color: #f3fcfe;
  width: 100%;
  overflow: hidden;
  height: ${({ height }) => height}px;
  transition: height 0.3s ease;
`;

export const MobileDropdownItem = styled.a`
  display: block;
  padding: 2rem 2rem;

  color: ${({ theme }) => theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size20};
  text-decoration: none;
  text-align: center;

  &:hover,
  &.active {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const CloseIconWrapper = styled.span`
  position: absolute;
  top: 3rem;
  right: 2rem;
`;

export const NavLinkWithDropdown = styled.div`
  position: relative;
  font-size: ${({ theme }) => theme.fontSize.size20};

  &:hover ${DropdownMenu} {
    display: block;
  }

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 3.5rem;
    background: transparent;
  }
`;
export const PortfolioBar = styled.div<{ isOpen: boolean }>`
  background: #f3fcfe;
  width: 100%;

  overflow: hidden;

  max-height: ${({ isOpen }) => (isOpen ? '300px' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};

  transition:
    max-height 0.5s ease,
    opacity 0.3s ease;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    display: none;
  }
`;

export const PortfolioLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  padding: 2rem 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-wrap: wrap;
    gap: 2rem;
  }
`;

export const PortfolioLink = styled.span<{ isActive: boolean }>`
  color: ${({ theme, isActive }) =>
    isActive ? theme.color.mobilityBlue : theme.color.mobilityGrey};
  cursor: pointer;
  font-family: proxima-nova, sans-serif;
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight600};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.color.mobilityBlue};
  }
`;

export const IconWrapper = styled.span`
  cursor: pointer;
`;

export const LanguageSwitcherMobileContaner = styled.div`
  display: flex;
  justify-content: center;

  border-top: 3px solid ${({ theme }) => theme.color.lightGrey};
  font-family: proxima-nova, sans-serif;
  margin-top: 6rem;
  padding: 8rem 0;
  width: 100%;
`;
